/**
 * <b>현재 등록되어 있는 폰트를 보여줍니다.</b>
 * <pre>
 * name - font family를 입력합니다. 일치해야합니다.
 * alias_name - font family를 다 적는건 너무 비효율적입니다. 여기에 등록하면 간편하게 사용할 수 있습니다.
 * </pre>
 */
const fonts = [{
	name: "",
	alias_name: [""]
},
{
	name: "NotoSans-Bold",
	alias_name: ["NotoB", "NoB"]
},
{
	name: "NotoSans-Regular",
	alias_name: ["NotoR", "NoR"]
},
{
	name: "BMJUA_ttf",
	alias_name: "JUA"
},
{
	name: "Roboto-Regular",
	alias_name: ["RobotoR", "RoR"]
},
{
	name: "Roboto-Bold",
	alias_name: ["RobotoB", "RoB"]
},
{
	name: "AppleSDGothicNeo-Bold",
	alias_name: ["AppleSDB", "ASB"]
},
{
	name: "AppleSDGothicNeo",
	alias_name: ["AppleSDR", "AppleSD", "AS", "ASR"]
}
];

/**
 * <b>등록되어 있는 폰트를 찾아줍니다.</b><br>
 * fonts에 등록되어있는 변수를 찾아서 있으면 해당 폰트를 리턴하고 없으면 기본 글꼴을 반환하는 클래스입니다.
 * 해당 클래스는 싱글턴으로 구현되어있으며 인스턴스를 생성해서는 안됩니다.
 * 폰트를 추가하고 싶으면 /views/global/css/cfont.css에 등록한 후 해당 클래스 소스의 fonts에 추가시켜줍니다.
 */
class FontSearcher {
	/**
     * static 생성자 입니다.
     */
	static init() {}

	/**
     * fonts에 등록된 글꼴의 font family를 비교하여 같거나 별명이 같으면 찾아줍니다. 없으면 null을 반환합니다.
     * @param {String} str 
     * @return fonts에 등록된 글꼴의 font family를 비교하여 같거나 별명이 같으면 찾아줍니다. 없으면 null을 반환합니다.
     */
	static find(str) {
		for (const font of fonts) {
			if (typeof font.alias_name !== "string" && typeof font.alias_name !== "object" && !font.alias_name.length) {
				return null;
			}
			if (typeof font.alias_name === "string") {
				if (font.alias_name === str) {
					return font.name;
				}
			} else {
				for (const atom of font.alias_name) {
					if (atom === str) {
						return font.name;
					}
				}
			}

		}
		for (const font of fonts) {
			if (font.name === str) {
				return font.name;
			}
		}
		return null;
	}
}

export default FontSearcher;

FontSearcher.init();